import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Typography, Box } from "@mui/material";

const useStyles = (theme) => ({
  container: {
    width: { xs: "161px", md: "170px", lg: "235px" },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  typography: {
    color: theme.palette.blue.main,
    fontFamily: theme.typography.anaHeim.regular,
    fontSize: { xs: "19px", md: "23px" },
    lineHeight: { xs: "24px", md: "32px" },
    textAlign: "center",
    mt: "26.5px",
  },
});

const LaborInsertionCard = ({ index, img, maxWidth, text, marginBottom }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box sx={{ ...classes.container, marginBottom }}>
      <img src={img} alt={`job placement ${index + 1}`} />
      <Typography
        sx={{
          ...classes.typography,
          maxWidth,
          width: { md: "170px", lg: "235px" },
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default LaborInsertionCard;
